(function () {
  'use strict';

  var banner = document.querySelector('[data-cookie-consent]');
  var dialog = document.querySelector('[data-cookie-dialog]');
  if (!banner || !dialog) return;

  var storageKey = banner.dataset.storageKey || 'rpf-cookie-consent-v1';
  var form = dialog.querySelector('[data-cookie-form]');
  var api = null;
  var choice = null;
  var localPreview = location.hostname === '127.0.0.1' || location.hostname === 'localhost';

  function readStored() {
    try { return JSON.parse(localStorage.getItem(storageKey) || 'null'); } catch (e) { return null; }
  }

  function store(consent) {
    try { localStorage.setItem(storageKey, JSON.stringify(consent)); } catch (e) {}
  }

  function normalize(value) { return value === true || value === 'yes' || value === 'true'; }

  function readApiConsent() {
    if (!api || typeof api.currentVisitorConsent !== 'function') return null;
    var current = api.currentVisitorConsent();
    if (!current) return null;
    var decided = ['analytics', 'marketing', 'preferences', 'sale_of_data'].some(function (key) {
      return current[key] === 'yes' || current[key] === 'no' || typeof current[key] === 'boolean';
    });
    if (!decided) return null;
    return {
      analytics: normalize(current.analytics),
      marketing: normalize(current.marketing),
      preferences: normalize(current.preferences),
      sale_of_data: normalize(current.sale_of_data)
    };
  }

  function setFormValues(consent) {
    consent = consent || { analytics: false, marketing: false, preferences: false, sale_of_data: false };
    ['analytics', 'marketing', 'preferences', 'sale_of_data'].forEach(function (key) {
      if (form.elements[key]) form.elements[key].checked = Boolean(consent[key]);
    });
  }

  function hideBanner() { banner.hidden = true; }
  function showBanner() { banner.hidden = false; }
  function openPreferences() {
    setFormValues(choice || readApiConsent() || readStored());
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
  }
  function closePreferences() {
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
  }

  function saveConsent(consent) {
    choice = consent;
    store(consent);
    document.documentElement.dataset.rpfCookieState = consent.analytics || consent.marketing || consent.preferences ? 'partial' : 'necessary';
    hideBanner();
    closePreferences();
    if (!localPreview && api && typeof api.setTrackingConsent === 'function') {
      api.setTrackingConsent({ analytics: consent.analytics, marketing: consent.marketing, preferences: consent.preferences, sale_of_data: consent.sale_of_data }, function () {});
    }
  }

  function all(value) { return { analytics: value, marketing: value, preferences: value, sale_of_data: value }; }

  function start() {
    api = window.Shopify && window.Shopify.customerPrivacy ? window.Shopify.customerPrivacy : null;
    choice = readApiConsent() || readStored();
    var apiRequestsBanner = api && typeof api.shouldShowBanner === 'function' && api.shouldShowBanner();
    if (!choice && (banner.dataset.displayMode === 'all' || apiRequestsBanner || !api)) showBanner();
  }

  banner.querySelector('[data-cookie-accept]').addEventListener('click', function () { saveConsent(all(true)); });
  banner.querySelector('[data-cookie-reject]').addEventListener('click', function () { saveConsent(all(false)); });
  banner.querySelector('[data-cookie-settings]').addEventListener('click', openPreferences);
  dialog.querySelector('[data-cookie-close]').addEventListener('click', closePreferences);
  dialog.addEventListener('click', function (event) { if (event.target === dialog) closePreferences(); });
  form.addEventListener('submit', function (event) {
    event.preventDefault();
    saveConsent({ analytics: form.elements.analytics.checked, marketing: form.elements.marketing.checked, preferences: form.elements.preferences.checked, sale_of_data: form.elements.sale_of_data.checked });
  });
  document.querySelectorAll('[data-cookie-open]').forEach(function (button) { button.addEventListener('click', openPreferences); });

  if (!localPreview && window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], start);
  } else start();
})();
